import { render, staticRenderFns } from "./GradeBook.vue?vue&type=template&id=7bead368&scoped=true"
import script from "./GradeBook.vue?vue&type=script&lang=js"
export * from "./GradeBook.vue?vue&type=script&lang=js"
import style0 from "./GradeBook.vue?vue&type=style&index=0&id=7bead368&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bead368",
  null
  
)

export default component.exports